export enum AssemblyOrderEnum {
    Pendiente = 1,
    Bloqueada = 2,
    EnPreparacion = 3,
    Armada = 4,
    Modificada = 5,
    Cancelada = 6,
    Reprogramada = 7,
    Programado = 8,
    Pospuesta = 9
}

export enum AssemblyTaskStatusEnum {
    Pendiente = 1,
    EnProceso = 2,
    Listo = 3,
    Modificada = 4,
}

export enum AssemblyPoolShellStatusEnum {
    Pendiente = 1,
    Programada = 2,
    Listo = 3,
    Modificada = 4,
}